import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * shadcn radix-nova Input primitive.
 *
 * Inherits all colours from the `--input` / `--ring` / `--primary` / `--muted-foreground`
 * CSS variables in `src/styles/globals.css` (see `colours.md` §2.3 + §2.5 + §2.4).
 * Includes the `peer` class so the matching `<Label>` peer-disabled flow dims when
 * the input becomes disabled, and the file-* + selection-* + aria-invalid-* hooks
 * the shadcn baseline ships with.
 */
const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentPropsWithoutRef<"input">
>(({ className, type, ...props }, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "flex h-9 w-full min-w-0 rounded-lg border border-input bg-transparent px-3 py-1 text-base transition-colors outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 peer",
        className,
      )}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
